import React from 'react';

type Identifiers = {
  id: string;
  className?: string;
};

type RadioInteractions = {
  onClick?: (checkedValue: string) => void;
};

type RadioOptions = {
  checked?: boolean;
  disabled?: boolean;
  identifiers: Identifiers;
  label: string;
  value: string;
  className?: string;
};

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  identifiers: Identifiers;
  interactions?: RadioInteractions;
  radioOptions: RadioOptions[];
  error?: string;
  showDefaultRadioIcon?: boolean;
}

const RadioGroup: React.FC<RadioProps> = ({
  identifiers: { id, className = '' },
  interactions: { onClick } = {},
  radioOptions,
  error,
  showDefaultRadioIcon = false,
  ...props
}) => {
  const baseRadioClasses =
    'px-4 py-2 rounded-xl border cursor-pointer text-center text-xl font-normal leading-6';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onClick?.(value);
  };

  return (
    <div id={id} className={`w-full ${className}`}>
      <div className={`grid grid-cols-2 gap-x-8 gap-y-4 w-full`}>
        {radioOptions?.map(option => {
          const selectedClasses = option.checked
            ? 'bg-[#00146b] text-[#fcfcfc]'
            : 'bg-[#fcfcfd] text-[#000]';
          return (
            <label
              key={option.identifiers.id}
              id={`label-${option.identifiers.id}`}
              className={`${baseRadioClasses} ${selectedClasses} ${option.className ?? ''}`}
            >
              <input
                type="radio"
                checked={option.checked}
                id={option.identifiers.id}
                value={option.value}
                disabled={option?.disabled}
                onChange={e => !option.disabled && handleChange(e)}
                className={showDefaultRadioIcon ? '' : 'hidden'}
                {...props}
              />
              {option.label}
            </label>
          );
        })}
      </div>
      {error && (
        <p className="text-[#eb5757] text-base font-semibold mt-2 whitespace-nowrap">
          {error}
        </p>
      )}
    </div>
  );
};

export default RadioGroup;
